import { create } from 'zustand'

const useCarePodsStore = create(set => ({
  carePodIds: [],
  setCarePodIds: v => set({ carePodIds: v }),

  carePodNames: [],
  setCarePodNames: v => set({ carePodNames: v })
}))

export default useCarePodsStore
